import { differenceBy } from "lodash";
import { Toast } from "@sscs/ui";
import { GROUP_ROLE_DETAILS, ORG_ROLE_DETAILS } from "Constants";
import { CurrentUserUpdatesMessage, WhoamiResponse } from "Types";

export const updateWhoamiCache = (
  draft: WhoamiResponse,
  message: CurrentUserUpdatesMessage,
): WhoamiResponse => {
  // If action was done by current user return and don't notify
  if (draft.email === message.initiated_by) return message.data;

  // Changes were done by another user
  // We want to notify for every change that happened

  // Handle organization role change
  if (message.data.org_role !== draft.org_role) {
    Toast.show({
      title: `Your organization role has been changed from 
                    ${ORG_ROLE_DETAILS[draft.org_role]?.label} to ${
                      ORG_ROLE_DETAILS[message.data.org_role]?.label
                    } by ${message.initiated_by}`,
      type: "info",
      props: {
        autoClose: false,
      },
    });
  }

  const userBelongsToGroups = draft.org_groups.filter(
    (group) => group.user_belongs === true,
  );

  // Handle group role change for groups user belongs to
  userBelongsToGroups.forEach((group) => {
    const updatedGroup = message.data.org_groups.find(
      (item) => item.group_id === group.group_id && item.role !== null,
    );

    // Notify user when their role for any of the groups they belong to changes
    if (updatedGroup && updatedGroup.role !== group.role) {
      Toast.show({
        title: `Your group role for ${group.name} group has been changed
                    from ${group.role && GROUP_ROLE_DETAILS[group.role]?.label}
                    to ${
                      updatedGroup.role &&
                      GROUP_ROLE_DETAILS[updatedGroup.role]?.label
                    } by ${message.initiated_by}`,
        type: "info",
        props: {
          autoClose: false,
        },
      });
    }
  });

  // User has been added to groups or removed from groups
  const addedTo = differenceBy(
    message.data.org_groups.filter((group) => group.user_belongs === true),
    userBelongsToGroups,
    "group_id",
  );
  const removedFrom = differenceBy(
    userBelongsToGroups,
    message.data.org_groups.filter((group) => group.user_belongs === true),
    "group_id",
  );

  // Notify user when they are removed from one or more groups
  if (removedFrom.length > 0) {
    Toast.show({
      title: `You have been removed from ${removedFrom
        .map((item) => item.name)
        .join(", ")} group${removedFrom.length > 1 ? "s" : ""} by ${
        message.initiated_by
      }`,
      type: "info",
      props: {
        autoClose: false,
      },
    });
  }

  // Notify user when they are added to a group
  if (addedTo.length > 0) {
    Toast.show({
      title: `You have been added to ${addedTo
        .map((item) => item.name)
        .join(", ")} group${addedTo.length > 1 ? "s" : ""} by ${
        message.initiated_by
      }`,
      type: "info",
      props: {
        autoClose: false,
      },
    });
  }

  return message.data;
};
